export class NodePageCampaignPage extends DrupalBehavior {
  onContent(context) {}
}

DrupalBehavior.register(
  'rush_theme.node_page',
  'campaign_page',
  NodePageCampaignPage
);
